<template>
    <div class="pageList">
        <div class="list" >
        <!-- <div class="list" > -->
            <div class="nav">
                <div class="borders"></div>
                <p class="fontw" v-if="(baseInfo.type==1)" style="font-size:20px">陕西靖边星源实业有限公司采购过磅单</p>
                <p class="fontw" v-else style="font-size:20px">陕西靖边星源实业有限公司销售过磅单</p>
            </div>
            <div class="listnum">
                <p class="name">磅单编号</p>
                <p class="value">{{baseInfo.poundSn}}</p>
            </div>
            <div class="listnum">
                <p class="name" v-if="(baseInfo.type==1)">供货单位</p>
                <p class="name" v-else>收货单位</p>
                <p class="value">{{baseInfo.companyName}}</p>
            </div>
            <div class="listnum">
                <p class="name">提货方式</p>
                <p class="value">自提</p>
            </div>
            <div class="listnum">
                <p class="name">产品</p>
                <p class="value">{{baseInfo.goodsName}}</p>
            </div>
            <div class="listnum" style="height: 50px;">
                <p class="name">主车号</p>
                <div style="width: 80%;">
                    <p class="value">{{baseInfo.plateNumber}}</p>
                    <p class="value" style="margin-left: 50rpx;">{{baseInfo.carriageNumber}}</p>
                </div>
            </div>
            <div class="listnum">
                <p class="name">铅封号</p>
                <p class="value">{{baseInfo.leadSealNo==null?'':baseInfo.leadSealNo}}</p>
            </div>
            <div class="listnum">
                <p class="name">皮重</p>
                <p class="value">{{baseInfo.firstWeight}}吨</p>
            </div>
            <div class="listnum">
                <p class="name">毛重</p>
                <p class="value">{{baseInfo.secondWeight}}吨</p>
            </div>
            <div class="listnum">
                <p class="name">净重</p>
                <p class="value">{{baseInfo.netWeight}}吨</p>
            </div>
            <div class="listnum">
                <p class="name">皮重时间</p>
                <p class="value">{{baseInfo.startTime}}</p>
            </div>
            <div class="listnum">
                <p class="name">毛重时间</p>
                <p class="value">{{baseInfo.endTime}}</p>
            </div>
        
            <div class="listnum" style="font-weight: bold;font-size: 15px;color:#4c4c4c">
                磅单真伪请进入<a style="color:#0000CD;font-size: 28rpx;cursor: pointer;" @click="goToPage()">https://security.jbxylng.com</a>查询
            </div>
            <div class="sign-box">
                <div class="qrcode">
                    <div style="width: 100%;height: 100%;" id="qrcode" ref="qrcode"></div>
                </div>
                <div>
                    <img src="../../assets/img/specialSeal.jpg" width="180" height="180">
                </div>
            </div>
            <div class="sign-box" style="margin-top:-30px">
                <div class="sign-box-child">
                    <div class="nav" style="margin-top:6px;">
                        <p>过磅员</p>
                    </div>
                    <div class="listnum" style="height: 90px;">
                        <div class="imgborder">
                        <img class="img" :src="baseInfo.registerSignImg" alt=""/>
                        </div>
                    </div>
                </div>
                <div class="sign-box-child">
                    <div class="nav" style="margin-top:6px;">
                        <p>驾驶员</p>
                    </div>
                    <div class="listnum" style="height: 90px;">
                        <div class="imgborder">
                        <img class="img" :src="baseInfo.driverSignImg" alt=""/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import QRCode from 'qrcodejs2'

    export default {
    name: "poundDetail",
    props: {
        baseInfo: {
            type: Object,
            default: function() {
                return {}
            }
        },
    },
    data() {
        return {
            url:'',
            qrcode:''
        };
    },
    mounted() {
        this.createQrcode()
    },
    methods: {
        createQrcode() {
            if(this.qrcode) {  // 有新的二维码地址了，先把之前的清除掉
                this.$refs.qrcode.innerHTML = ''
            }
            if(this.baseInfo.qrCode){
                this.qrcode = new QRCode(this.$refs.qrcode, {
                    text: this.baseInfo.qrCode, //页面地址 ,如果页面需要参数传递请注意哈希模式#
                    width: 120, // 二维码宽度 （不支持100%）
                    height: 120, // 二维码高度 （不支持100%）
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.H,
                })
            }
        },
        goToPage(){
            window.open("https://security.jbxylng.com",'电子磅单')
        }
    },
    };
</script>
 
<style lang="scss">
.pageList{
    width:100%;
    margin-top:-20px;
    // position: relative;
}
.list{
    width:100%;
    // position: absolute;
    /* top:30px; */
    flex-direction: column;
    display: flex;
    background-color: #fff;
    background-position: 72% 76%;
    background-size: 160px 160px;
	background-repeat: no-repeat;
    padding:13px;
    align-content: space-around;
    flex-wrap: wrap;
    align-content: space-between;
}
.fontw{
  font-weight: bold;
}
.nav{
    display:flex;
}
.nav p{
    margin-left:6px;
    margin-bottom: 10px;
}
.borders{
    margin-top:3px;
    width:3px;
    height:17px;
    background-color:#1890ff;
}
.listnum{
    display:flex;
    margin-top:6px;
    height:35px
    /* margin-top:15px; */
}
.sign-box{
    margin-top: 20px;
  display:flex;
  justify-content: space-between;
}
.sign-box-child{
  width: 50%;
}
.listnum .name{
    display:block;
    width: 20%;
    margin-right: 13px;
    font-size:15px;
    font-weight: bold;
    color:#4c4c4c;
    p-align-last: justify;
    p-align: justify;
    p-justify: distribute-all-lines;
}
.listnum .value{
    font-size:15px;
    color:#262626;
    width: 80%;
}
.qrcode{
  width:50%;
}
.qrcode-img{
  width:120px;
  height:120px;
  margin: 20px 0 0 0;
}
.imgborder{
    width:90%;
    /* width:70%; */
    /* height:130px; */
    /* border:1px solid #ccc; */
   margin-left:5%;
    /* border-radius:14px; */
}
.img{
    width:100%;
    height:88px;
    object-fit:scale-down
}
img[src=""],img:not([src]) { opacity: 0; }
</style>